import React, { useState } from 'react';
import api from '../api/api'; 
import { useNavigate, Link } from 'react-router-dom';
import logoCafe from '../assets/logoCafeBlancoB.png';
function Login({ onLoginSuccess }) {
    const navigate = useNavigate();
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
        const response = await api.post('/auth/login', { identifier, password });
        const { accessToken, user } = response.data;

        if (!accessToken) {
            setError('No se recibió token válido');
            return;
        }

        // 1. Guardar Token y Objeto Usuario Completo (Importante para detectar el ROL)
        localStorage.setItem('token', accessToken);
        localStorage.setItem('user', JSON.stringify(user)); // Guardamos el rol aquí
        
        if (onLoginSuccess) onLoginSuccess(accessToken);

        // 2. Lógica de Redirección por Rol
        if (user.rol === 'Admin') {
            navigate('/admin');
        } else if (user.rol === 'Empleado') {
            navigate('/dashboard-empleado'); // Nueva ruta
            
        } else {
            navigate('/bienvenida'); // Ruta para Clientes
        }

    } catch (err) {
        console.error(err);
        setError('Email o contraseña incorrectos');
    }
};
    // --- ESTILOS ADAPTADOS AL DASHBOARD AZULADO ---

    const dotAnimationCss = `
        @keyframes moveDots {
            0% { background-position: 0 0; }
            100% { background-position: 400px 400px; }
        }
        /* Esta animación usa puntos blancos semi-transparentes sobre el fondo oscuro */
        .animated-background-dots::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: radial-gradient(#ffffff20 1px, transparent 1px);
            background-size: 40px 40px;
            animation: moveDots 60s linear infinite;
            z-index: 0;
        }
    `;

    const PAGE_CONTAINER = { 
        minHeight: '100vh', 
        background: '#2E5B2E', // Fondo Principal: Verde Sierra
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden'
    };
    
    // Botones de navegación (Verde Sierra)
    const navBarButtonStyle = { 
        background: 'transparent', 
        color: '#FFFFFF', 
        padding: '10px 25px', 
        borderRadius: 25, 
        border: '1px solid #FFFFFF50', 
        fontWeight: 'bold',
        cursor: 'pointer',
        textDecoration: 'none',
        transition: 'all 0.3s ease',
        boxShadow: 'none',
        ':hover': {
            background: '#C19A6B', // Cantera Pink al pasar el mouse
            color: '#FFFFFF',
            transform: 'translateY(-1px)'
        }
    };
    
    // Tarjeta del Formulario (Blanca)
const formCardStyle = { 
        width: 480, 
        background: '#FFFFFF', // Fondo Blanco
        backdropFilter: 'none', 
        borderRadius: 20, 
        border: 'none', // Quitamos el borde para mayor limpieza
        padding: 45, 
        boxShadow: '0 15px 40px rgba(0,0,0,0.2)',
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        zIndex: 10,
        color: '#333333' // Texto base oscuro
    };
    
    // Banner de Bienvenida (Ahora es el logo y el texto)
    const welcomeBannerStyle = { 
        background: 'transparent', 
        color: '#2E5B2E',
        borderRadius: 0, 
        marginBottom: 35, 
        padding: '0', 
        width: '100%', 
        textAlign: 'center', 
        fontWeight: 'bold',
        fontSize: 26,
        letterSpacing: '0.5px',
        textShadow: 'none'
    };
    
    const inputStyle = { 
        width: '100%', 
        padding: 14, 
        marginBottom: 25, 
        borderRadius: 5, // Reducir radio
        background: '#FFFFFF', // Fondo Blanco
        fontSize: 18, 
        border: '1px solid #C19A6B', // Borde Cantera Pink
        color: '#333333',
        transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
        boxShadow: 'none',
        ':focus': {
            borderColor: '#2E5B2E', 
            boxShadow: '0 0 0 3px rgba(46, 91, 46, 0.3)'
        }
    };
    
    // Botón Principal (Verde Sierra)
    const submitButtonStyle = { 
        width: '100%', 
        background: '#2E5B2E', // Verde Sierra
        color: '#FFFFFF', 
        padding: 18, 
        borderRadius: 8, // Borde ligeramente redondeado
        fontWeight: 'bold', 
        fontSize: 20, 
        border: 'none', 
        marginBottom: 15,
        cursor: 'pointer',
        transition: 'background 0.3s ease, transform 0.2s ease',
        boxShadow: '0 5px 15px rgba(46, 91, 46, 0.4)',
        ':hover': {
            background: '#C19A6B',
            transform: 'translateY(-2px)'
        }
    };
    
    // Botón Secundario (Borde Cantera Pink)
    const secondaryButtonStyle = { 
        width: '100%', 
        background: 'transparent', 
        color: '#C19A6B', // Texto Cantera Pink
        padding: 12, 
        borderRadius: 8, 
        fontSize: 16, 
        border: '1px solid #C19A6B', // Borde Cantera Pink
        cursor: 'pointer',
        transition: 'background 0.3s ease, border-color 0.3s ease',
        ':hover': {
            background: '#C19A6B10', 
            borderColor: '#2E5B2E'
        }
    };

    const labelStyle = { 
        marginBottom: 5, 
        display: 'block', 
        fontWeight: 'bold', 
        color: '#333333', // Etiqueta Charcoal Grey
        fontSize: 16 
    };

    return (
        <div style={PAGE_CONTAINER} className="animated-background-dots">
            {/* Insertar la animación CSS directamente */}
            <style>{dotAnimationCss}</style>

            {/* Barra superior (Alineación con el mockup) */}
            <div style={{ width: 480, display: 'flex', justifyContent: 'flex-end', alignItems:'center', marginBottom: 50, zIndex: 10 }}>
                {/* LOGO LINK (Movido a la Tarjeta para centralizar) */}
                <Link to="/contacto" style={{...navBarButtonStyle, color: '#FFFFFF', border: '1px solid #FFFFFF', padding:'8px 18px'}}>Contactar</Link>
                <Link to="/" style={{...navBarButtonStyle, background: '#C19A6B', color: '#FFFFFF', border:'none', marginLeft: 10}}>Inicio</Link> 
            </div>
            
            {/* Card central */}
            <div style={formCardStyle}>
                <div style={welcomeBannerStyle}>
                    {/* Sustituir el banner por la imagen central y el texto */}
                    <img src={logoCafe} alt="Xavana Logo" style={{height: 200, marginBottom: 5}} />
                    <div style={{color: '#2E5B2E', fontSize: 24, fontWeight: 'bold'}}>Bienvenido</div>
                </div>
                <form style={{ width: '100%' }} onSubmit={handleSubmit}>
                    <label style={labelStyle}>Usuario o Email</label>
                    <input type="text" value={identifier} onChange={e => setIdentifier(e.target.value)} style={inputStyle} required />
                    
                    <label style={labelStyle}>Contraseña</label>
                    <input type="password" value={password} onChange={e => setPassword(e.target.value)} style={inputStyle} required />
                    
                    <button type="submit" style={submitButtonStyle}>Ingresar</button>
                    
                    {error && <div style={{ color: '#ef4444', textAlign: 'center', marginBottom: 15, fontSize: 16 }}>{error}</div>}
                </form>
                {/* <button style={secondaryButtonStyle}>Olvidé mi contraseña</button> */}
            </div>
        </div>
    );
}

export default Login;